module.exports = __webpack_public_path__ + "img/6-1.86e9a26a.svg";